<template>
	<div class="container bg_main">

		<div class="fullwidth padding15">
			<div class="bg_fff radius10">
				<div bindtap="toMyAddr" class="my_addr flex_row bg_white hidden">
					<div class="size4">我的收货地址</div>
					<img class="right_icon" src="@/assets/images/arrow_right.png" />
				</div>
				

				<div class="fullwidth padding15">

					<form bindsubmit="saveContact" report-submit="true">

						<div class="order_item  ">
							<div class="middle uni-icon uni-icon-info-filled"></div><span class="marginl5">收货地址</span>
						</div>
						<div class=" flex_row padding010 margint10">
							<div class="padding0 width80">区域</div>
							<div @click="toSelectArea" class="ellips bg_white inputh40 borderb fullwidth">
								{{detail.area}}
							</div>
						</div>
						<!-- <div class="section">
							<picker @change="bindRegionChange" :value="index" :range="area" class=" order_item_btn ">
								<div class="picker ">
									{{area[0]}}，{{area[1]}}，{{area[2]}}
								</div>
							</picker>
						</div> -->
						<input v-if="!!detail.area==true" class="margint5 bg_white border padding10 height50"
							v-model="detail.address" name="address" placeholder="请填写详细地址"/>


						<div class="margint20">
							<div class="middle uni-icon uni-icon-info-filled"></div><span class="marginl5">收货人</span>
						</div>
						<input class=" border bg_white padding10 height50" v-model="detail.contacter" name="contacter"
							placeholder="请填写收货人"/>

						<div class="margint20">
							<div class="middle uni-icon uni-icon-info-filled"></div><span class="marginl5">手机</span>
						</div>
						<input class=" border bg_white padding10 height50" v-model="detail.phone" name="phone"
							placeholder="请填写手机"/>
						<div v-if="!!user.id==false && !!detail.phone==true" class="flex_row padding0 margint5">
							<input class=" border bg_white padding10 height50" v-model="detail.smsCode" name="smsCode"
								placeholder="填写短信验证码"/>
							<div @click="sendSmsCode" class="color_blue">发送验证码</div>
						</div>


						
					</form>

					
						<div class="fixed bottom0 padding10 h5maxwidth left0 right0 automargin fullwidth">
							<div class="flex_row padding0  automargin ">
								<div @click="toExit" class=" flex1 bg_grey1 center radiusl20 size4 lineh1 padding15">取消</div>
								<div @click="saveContact"
									class="flex1 radiusr20 center radius20 size4 bg_red color5 margin0 lineh1 padding15">确定
								</div>
							</div>
						</div>
				</div>

			</div>
		</div>


		<mypop-unslider ref="selectarea_pop">
			<selectarea mOpenMode="1" @selectItemCallback="selectItemCallback"></selectarea>
		</mypop-unslider>

		<ydverify :showPopup="showPopup" @imgVerifySuccessCallback="imgVerifyCallback" ref="cnverify_popup">
			<template v-slot:imgverify_head>{{verifyPopupTitle}}</template>
		</ydverify>
	</div>
</template>

<script>

	import mypopUnslider from '@/components/mypop-unslider/mypop-unslider.vue';
	import ydverify from '@/components/imgverify/ydverify.vue';
	import uniLoadMore from '@/components/uni-load-more/uni-load-more.vue';
	import selectarea from '@/views/common/selectarea';
	//
	// var app = getApp();

	export default {
		components: {
			uniLoadMore,
			selectarea,
			ydverify,  mypopUnslider
		},
		data() {
			return {
				user: {},
				detail: {},
				area: [],
				index: 0,
				showPopup: false,

				//------------------
				banner: {},
				listData: [],
				page: 1,
				totalPage: 0,
				last_id: '',
				reload: false,
				status: 'more',
				adpid: '',
				contentText: {
					contentdown: '上拉加载更多',
					contentrefresh: '加载中',
					contentnomore: '没有更多'
				}
			};
		},
		created() {
			
			var options=this.$route.query || {};
			console.log(options);
			this.user = window.$utils.uniapi.getStorageSync("user") || {};


			if (options && options.action == 'from_order') {
				this.isFromOrder = true;
			}
			if (options && !!options.id == true) {
				this.id = id;
			}

			// var detail=options.detail;
			// this.setData({
			//   detail:JSON.parse(decodeURIComponent(detail))
			// });

			// wx.setNavigationBarColor({
			// 	frontColor: '#000000',
			// 	backgroundColor: app.statusBarBg,
			// 	animation: {
			// 		duration: 30,
			// 		timingFunc: 'linear'
			// 	}
			// });


			// var mLoc = app.getMyLocation();
			// if (typeof mLoc.area != 'undefined') {
			// 	this.area = mLoc.area;
			// }
			this.cartGoodsList = window.$utils.uniapi.getStorageSync('cartGoodsList') || [];

		},
		mounted() {

			//this.$refs.selectarea_pop.close();

			try {
				var selectedContact =  window.$utils.uniapi.getStorageSync('selectedContact') || {};
				if (typeof selectedContact.area != 'undefined') {
					this.detail = selectedContact;
					this.area = selectedContact.area.split(",");
					 window.$utils.uniapi.removeStorageSync('selectedContact');
				}
			} catch (e) {
				console.log(e);
			}

		},

		onPullDownRefresh() {
			this.reload = true;
			this.last_id = '';
			this.getAdvList();
			this.page = 1;
			this.getList();
			//uni.stopPullDownRefresh();
		},
		onReachBottom() {
			this.status = this.page >= this.totalPage ? "nomore" : 'more';
			if (this.page < this.totalPage) {
				this.page++;
				this.getList();
			}
		},
		methods: {

			toMyAddr: function() {
				this.$router.push('/order_addr_list'); 
			},


			//区域选择
			bindRegionChange(e) {
				console.log(e);
				var area = e.detail.value;
				var areaCode = e.detail.code;
				this.setData({
					area: area
				});
			},


			saveContact() {
				console.log("save收货地址");
				var that = this;
				//请求
				var params = that.detail;
				this.$axios.request({
						url: window.$config.url.saveContact,
						data: params
					})
					.then(res => {
						if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {
							//uni.stopPullDownRefresh();
							alert("成功" );
							//无用户时，保存用户
							if(typeof that.user.id=='undefined'){
								var d=res.data;
								if(typeof d=='string')d=JSON.parse(d);
								var user=d.accountEntity;
								if(typeof user=='string')user=JSON.parse(user);
								window.$utils.uniapi.setStorageSync("user",user);
							}
							 window.$utils.uniapi.navigateBack({});
						} else {
							alert( res.msg );
						}
					});
			},


			toOrder() {

				if (this.isFromOrder) {
					this.$router.go(-1);
				} else {
					this.$router.push({ path: '/order_addr_list' })
				}

			},


			toExit() {
				this.$router.go(-1);
				return;
				// if (this.isFromOrder) {
				// 	wx.redirectTo({
				// 		url: '/pages/order/order/order',
				// 		success: (result) => {},
				// 		fail: (res) => {},
				// 		complete: (res) => {},
				// 	})
				// } else {
				// 	wx.switchTab({
				// 		url: '/pages/member/mine/mine',
				// 		success: (result) => {},
				// 		fail: (res) => {},
				// 		complete: (res) => {},
				// 	})
				// }
			},
			toSelectArea() {
				this.$refs.selectarea_pop.open("right");
			},
			selectItemCallback(item) {
				console.log(item);
				this.detail.area = item;
				this.$forceUpdate();
				this.$refs.selectarea_pop.close();
			},

			//发送短信验证码
			sendSmsCode(){
				var that=this;
				
				//显示popup
				this.showPopup=true;
				this.$refs.cnverify_popup.getVerifyCode(this.detail.phone); //调用popup插件方法
				this.verifyPopupTitle="即将发送短信验证码";
				this.imgVerifyEvent="sendsms";

			},
			// 旋转图片完成回调
			imgVerifyCallback(d) {
				console.log("旋转图片完成回调", d);
				var that = this;
				that.showPopup = false;
				if (this.imgVerifyEvent == "sendsms") {

					//发送短信
					that.$axios.request({
							url: window.$config.url.sendSmsCode,
							data: {
								phone: that.detail.phone,
								imgVerifyKey: d.imgVerifyKey,
								imgVerifyVal: d.imgVerifyVal,
							}
						})
						.then(res => {

							if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {
								alert( res.msg);

							} else if (!!res.msg == true) {
								alert( res.msg );
							} else {
								alert(  "不成功" );
							}
						});
				}

			},

		}
	};
</script>

<style scoped>
	.banner {
		height: 180px;
		overflow: hidden;
		position: relative;
		background-color: #ccc;
	}

	.banner-img {
		width: 100%;
	}

	.banner-title {
		max-height: 42px;
		overflow: hidden;
		position: absolute;
		left: 15px;
		bottom: 15px;
		width: 90%;
		font-size: 16px;
		font-weight: 400;
		line-height: 21px;
		color: white;
		z-index: 11;
	}

	.uni-media-list-logo {
		width: 90px;
		height: 70px;
	}

	.uni-media-list-body {
		height: auto;
		justify-content: space-around;
	}

	.uni-media-list-text-top {
		height: 37px;
		font-size: 14px;
		overflow: hidden;
	}

	.uni-media-list-text-bottom {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
</style>


// WEBPACK FOOTER //
// src/views/order/addr_edit.vue